import React from "react";
import { motion } from "framer-motion";
import "./Tuition.css";

const Tuition = () => {
  const tuitionData = [
    {
      className: "2-year-old Class",
      days: "Monday/Wednesday/Friday",
      daysPerWeek: 3,
      classSize: 12,
      monthlyTuition: 346,
      supplyFee: 167,
      equipmentFee: 86,
    },
    {
      className: "2-year-old Class",
      days: "Tuesday/Thursday",
      daysPerWeek: 2,
      classSize: 12,
      monthlyTuition: 254,
      supplyFee: 140,
      equipmentFee: 86,
    },
    {
      className: "3-year-old Class",
      days: "Monday/Wednesday/Friday",
      daysPerWeek: 3,
      classSize: 14,
      monthlyTuition: 346,
      supplyFee: 167,
      equipmentFee: 86,
    },
    {
      className: "3-year-old Class",
      days: "Tuesday/Thursday",
      daysPerWeek: 2,
      classSize: 14,
      monthlyTuition: 254,
      supplyFee: 140,
      equipmentFee: 86,
    },
    {
      className: "4-year-old Class",
      days: "Monday–Friday",
      daysPerWeek: 5,
      classSize: 18,
      monthlyTuition: 518,
      supplyFee: 194,
      equipmentFee: 86,
    },
  ];

  return (
    <main className="tuition-page">
      {/* Hero Section */}
      <motion.section
        className="tuition-hero"
        initial={{ opacity: 0, y: -40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <div className="tuition-overlay"></div>
        <h1>Tuition Information</h1>
        <p>
          Welcome to our Tuition page. Learn about our fees and available
          scholarships.
        </p>
      </motion.section>

      {/* Tuition Cards */}
      <motion.section
        className="tuition-cards"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
        {tuitionData.map((item, idx) => (
          <motion.article
            className="tuition-card"
            key={idx}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: idx * 0.1 }}
            viewport={{ once: true }}
          >
            <h3>{item.className}</h3>
            <h4>{item.days}</h4>
            <div className="tuition-info-grid">
              <div>
                <strong>Days/Week</strong>
                <span>{item.daysPerWeek}</span>
              </div>
              <div>
                <strong>Class Size</strong>
                <span>{item.classSize}</span>
              </div>
              <div>
                <strong>Monthly Tuition</strong>
                <span>${item.monthlyTuition}</span>
              </div>
              <div>
                <strong>Supply Fee</strong>
                <span>${item.supplyFee}</span>
              </div>
              <div>
                <strong>Equipment Fee</strong>
                <span>${item.equipmentFee}</span>
              </div>
            </div>
          </motion.article>
        ))}
        <motion.article className="tuition-card"   initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, }}
            viewport={{ once: true }}>
          <h3>Lunch Bunch</h3>
          <h4>Monday through Friday from 12:00 PM to 1:00 PM</h4>
          <div>
            <strong>Tuition</strong>
            <span>$9 per day</span>
          </div>
        </motion.article>
      </motion.section>

      {/* Scholarships Section */}
      <motion.section
        className="scholarships-card"
        initial={{ opacity: 0, x: 60 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.7 }}
        viewport={{ once: true }}
      >
        <h2>Scholarships Available</h2>
        <p>
          Binkley Preschool believes that quality preschool should be available
          to all young children in the community. With support from Binkley
          Church, we offer need-based scholarships each year.
        </p>
        <p>
          To be considered in the initial distribution, applications must be
          received by the dates noted on the registration application, and both
          forms (registration and application) must be submitted together. For
          more information, please contact the Director of Binkley Preschool.
        </p>
        <a
          href="/contact"
          className="card-button"
          target="_blank"
          rel="noopener noreferrer"
        >
          Contact the Director
        </a>
      </motion.section>
    </main>
  );
};

export default Tuition;
